const React = require('react');

function hasHtml(value) {
  return /<\w.+>|&#\d+;/.test(value);
}

function toSpan(value) {
  return React.createElement("span", {'data-cy': 'has-html', dangerouslySetInnerHTML:{__html:value}});
}

export function parseTree(component) {
  if(component === undefined || component === null) return;

  for(const prop in component){
    if(prop === "dangerouslySetInnerHTML"){
      continue;
    } else if(typeof component[prop] == "object" && component[prop] !== null){
      parseTree(component[prop]);
    } else if(typeof component[prop] == "string" && hasHtml(component[prop]) && prop !== "ariaLabel"){
      component[prop] = toSpan(component[prop]); 
    }
  }
}
